import React, { useEffect } from 'react'
import "./Customer_Feedbacks_cards.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
import Rating from "react-rating";
import { useDispatch, useSelector } from 'react-redux';
import { appSetup } from '../../../../../features/master/masterSlice';

function Customer_Feedbacks_cards({nameText, imgSrc, dateText, productName, boldText,rating}) {

       const dispatch = useDispatch();
  const app_setup = useSelector((state) => state.master.app_setup);
  
    useEffect(() => {
      dispatch(appSetup());
    }, [dispatch]);


    return (
        <>
            <section className='Customer_Feedbacks_cards'>
                <div className='content_holder'>
                    <div className='profile_holder'>
                        <div>
                            <div className='img_holder'>
                                <img
                                    // src={
                                    //     process.env.PUBLIC_URL +
                                    //    "/assets/images/logo/new_ekansi_logo.png"
                                    // }
                                     src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                                    className="user_img"
                                    alt="user_img"
                                />
                            </div>
                        </div>
                        <div className='text_holder'>
                            <h6>{nameText}</h6>
                            <Rating
                                className='rating_icon'
                                initialRating={rating}
                                emptySymbol={<FontAwesomeIcon icon={farStar} color="#ccc" />}
                                fullSymbol={<FontAwesomeIcon icon={fasStar} color="#FFD700" />}
                                fractions={2}
                            />
                        </div>
                    </div>
                    <div className='date_holder'>
                        <h5>{dateText}</h5>
                    </div>
                </div>

                <div className='product_name'><p>{productName} : <b>{boldText}</b></p></div>
            </section>
        </>
    )
}

export default Customer_Feedbacks_cards
